import React, { useState, useEffect } from "react";
import { Box, Typography, CircularProgress, Button } from "@material-ui/core";
import { Link, useLocation, useHistory } from "react-router-dom";
import { Auth, API, graphqlOperation } from "aws-amplify";

const StripeConnect = () => {
  const [showCreateProductBtn, setShowCreateProductBtn] = useState(false);
  const [showLoading, setShowLoading] = useState(true);
  const [showError, setShowError] = useState(false);
  const [error, setError] = useState("");
  const location = useLocation();
  const history = useHistory();

  useEffect(() => {
    const connectStripe = async () => {
      try {
        const urlParams = new URLSearchParams(window.location.search);
        const code = urlParams.get("code");
        if (!code) throw new Error("コードが取得できません");

        // ユーザー情報を取得
        const currentUserInfo = await Auth.currentUserInfo();

        // GraphQLミューテーションを定義
        const GetStripeConnectID = `
          mutation GetStripeConnectID {
            getStripeConnectID(input: {
              code: "${code}",
              id: "${currentUserInfo.attributes.sub}"
            }) {
              statusCode
              body
            }
          }
        `;

        try {
          // GraphQLリクエストを実行しPromiseで処理
          API.graphql(graphqlOperation(GetStripeConnectID))
            .then((response) => {
              const res = response.data.getStripeConnectID.body;
              if (res.includes('Successful')) {
                setShowLoading(false);
                setShowCreateProductBtn(true);
              } else {
                setShowLoading(false);
                setShowError(true);
              }
            })
            .catch((e) => {
              console.log(e);
              setShowLoading(false);
              setShowError(true);
            });
        } catch (e) {
          console.log(e);
          setShowLoading(false);
          setShowError(true);
        }
      } catch (err) {
        console.error("Stripe連携エラー:", err);
        setShowError(true);
      } finally {
        setShowLoading(false);
      }
    };

    connectStripe();
  }, [location]);

  return (
    <Box 
      display="flex" 
      flexDirection="column" 
      alignItems="center" 
      justifyContent="center" 
      minHeight="100vh"
    >
      <Box 
        width="100%" 
        maxWidth="600px" 
        display="flex" 
        flexDirection="column" 
        alignItems="center"
      >
        {showLoading && (
          <div>
            <CircularProgress 
              style={{ marginBottom: "20px" }} 
              color="secondary" 
            />
          </div>
        )}
        
        {showCreateProductBtn && (
          <div>
            <Box textAlign="center" mb={1}>
              <Typography variant="body1">
                Stripeとの連携が完了しました
              </Typography>
            </Box>
            <Box textAlign="center" mb={2}>
              <Typography variant="body1">
                下記ボタンより商品を作成することができます
              </Typography>
            </Box>
            <Box textAlign="center" my={4}>
              <Button
                variant="contained"
                color="primary"
                component={Link}
                to="/products/new"
              >
                商品を作成する
              </Button>
            </Box>
          </div>
        )}
        
        {showError && (
          <div>
            <Box textAlign="center" mb={2}>
              <Typography color="error" variant="body1">
                問題が発生しました
              </Typography>
            </Box>
          </div>
        )}
      </Box>
    </Box>
  );
};

export default StripeConnect;
